import * as React from "react";
const SvgRightArrow = ({
  title,
  titleId,
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M21.791 9.5 19 12.341 32.417 26 19 39.659l2.791 2.841L38.001 26z" /></svg>;
export default SvgRightArrow;